import { render, staticRenderFns } from "./geolocation.vue?vue&type=template&id=180ef7c2&scoped=true"
import script from "./geolocation.vue?vue&type=script&lang=js"
export * from "./geolocation.vue?vue&type=script&lang=js"
import style0 from "./geolocation.vue?vue&type=style&index=0&id=180ef7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ef7c2",
  null
  
)

export default component.exports